<template>
  <path
    d="M12 2.00018C8.14 2.00018 5 5.14018 5 9.00018C5 13.1702 9.42 18.9202 11.23 21.1102C11.63 21.5902 12.36 21.5902 12.76 21.1102C14.58 18.9202 19 13.1702 19 9.00018C19 5.14018 15.86 2.00018 12 2.00018ZM16.31 8.16018L11.18 13.2902C10.79 13.6802 10.16 13.6802 9.77 13.2902L7.7 11.2202C7.31 10.8302 7.31 10.1902 7.7 9.80018C8.09 9.41018 8.73 9.41018 9.12 9.80018L10.48 11.1602L14.9 6.74018C15.29 6.35018 15.93 6.35018 16.32 6.74018C16.7 7.14018 16.7 7.77018 16.31 8.16018Z"
  />
</template>
